// eslint-disable-next-line import/no-unresolved
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';

import {
  MergedRetryData,
  RetryProcessAuthorisationResponse,
} from '../../adapters/retryApiAdapter.types';
import { Maybe } from '../../types';
import { DataFetchingState } from '../types';

export enum RetryActions {
  retry_fetch_success = 'retry_fetch_success',
  retry_fetch_fail = 'retry_fetch_fail',
  retry_fetch_error = 'retry_fetch_error',
  initiate_payment_start = 'initiate_payment_start',
  initiate_payment_success = 'initiate_payment_success',
  initiate_payment_failure = 'initiate_payment_failure',
  process_payment_authorisation_start = 'process_payment_authorisation_start',
  process_payment_authorisation_success = 'process_payment_authorisation_success',
  process_payment_authorisation_failure = 'process_payment_authorisation_failure',
}

export type RetryActionTypes =
  | { type: RetryActions.retry_fetch_success; payload: MergedRetryData }
  | { type: RetryActions.initiate_payment_start }
  | { type: RetryActions.initiate_payment_failure }
  | {
      type: RetryActions.initiate_payment_success;
      payload: { action: PaymentAction; paymentId: string; authorizationId?: string };
    }
  | { type: RetryActions.process_payment_authorisation_start }
  | { type: RetryActions.process_payment_authorisation_failure }
  | {
      type: RetryActions.process_payment_authorisation_success;
      payload: RetryProcessAuthorisationResponse;
    };

export interface InitiatePaymentData extends DataFetchingState {
  actionObject?: PaymentAction;
  paymentId?: string;
  authorizationId?: string;
}

export interface ProcessAuthorisationData extends DataFetchingState {
  authorizationResult?: RetryProcessAuthorisationResponse;
}

export interface RetryState {
  retryData: Maybe<MergedRetryData>;
  initiatePaymentData: Maybe<InitiatePaymentData>;
  processAuthorisationData: Maybe<ProcessAuthorisationData>;
  customerId: Maybe<string>;
}
